import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-schematic" }
const _hoisted_2 = { class: "as-schematic__body" }
const _hoisted_3 = { class: "as-quarter" }
const _hoisted_4 = { class: "as-semi" }
const _hoisted_5 = { class: "as-finals" }

import { ref, computed } from "vue";
import type { IMatch } from "~src/interfaces/tennis";
import SchematicItem from "./SchematicItem.vue";

const __default__ = {};

interface IProps {
    schematics: string[];
    match: IMatch;
    isHomePage: boolean;
  }


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SchematicListTab',
  props: {
    schematics: {},
    match: {},
    isHomePage: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "as-schematic__head" }, [
      _createElementVNode("span", null, "Tứ kết"),
      _createElementVNode("span", null, "Bán kết"),
      _createElementVNode("span", null, "Chung kết")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SchematicItem),
        _createVNode(SchematicItem),
        _createVNode(SchematicItem),
        _createVNode(SchematicItem)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "as-connecter" }, [
        _createElementVNode("div"),
        _createElementVNode("div")
      ], -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-line" }, [
        _createElementVNode("div"),
        _createElementVNode("div")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SchematicItem),
        _createVNode(SchematicItem)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-connecter as-connecter__semi" }, [
        _createElementVNode("div")
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "as-line as-line__semi" }, [
        _createElementVNode("div")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(SchematicItem, { isNull: true })
      ])
    ])
  ]))
}
}

})